import {CalculationExecutionLog} from "./component/calculation_log/calculationExecutionLog";
import {CalculationsLogService} from "../logging_lqb_funded/services/CalculationsLogService";
import {CalculationsLogServiceName, LqbPricerParameterServiceName} from "../utils/names/serviceNames";
import {LqbPricerLogParametersService} from "./service/LqbPricerLogParametersService";
import {LoggingController} from "./route/loggingController";
import {CalculationsLoggingControllerName} from "../utils/names/controllerNames";
import {CalculationLoggingModuleConfiguration} from "./calculationsLoggingModuleConfiguration";
import {CursorPagination} from "./component/cursor_pagination/cursorPagination";

CalculationLoggingModuleConfiguration
    .createNewModule()
    .controller(CalculationsLoggingControllerName, LoggingController.instance)
    .service(CalculationsLogServiceName, CalculationsLogService.instance)
    .service(LqbPricerParameterServiceName, LqbPricerLogParametersService.instance)
    .component('calculationExecutionLog', CalculationExecutionLog.instance)
    .component('cursorPagination', CursorPagination.instance);
